export const flags = ['usb-pairing', 'files', 'unify', 'connect'] as const;

export type Feature = typeof flags[number];

export interface PairedStats {
  lvs: number;
  devices: number;
  projects: number;
}

export type CodeStatus = 'ok' | 'invalid-code' | 'no-seats' | 'no-seats-expandable';

export type CapabilityState =
  | {
      enabled: true;
    }
  | {
      enabled: false;
      reason: 'no_subscription' | 'subscription_is_dq' | 'uetoken_exhausted' | 'overridden';
    };
